<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer :title="title" :visible.sync="drawer" size="70%" :wrapperClosable="false">
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :rules="rules"
          :disabled="isAi ? true : disabled"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="设备名称" prop="DeviceItemNameJson">
                <div style="width: 100%; display: flex; align-items: center">
                  <el-input
                    v-model="form.DeviceItemNameJson"
                    placeholder="请选择设备"
                    disabled
                    style="width: calc(100% - 60px)"
                  ></el-input>
                  <el-button
                    style="width: 60px"
                    type="primary"
                    @click="openDevice"
                    :disabled="dev.Id ? true : isAi ? true : disabled"
                    ><i class="el-icon-search"></i
                  ></el-button>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="故障类型" prop="FaultType">
                <SelectDicValue
                  ref="SelectDicValue"
                  code="TheFaultType"
                  v-model="form.FaultType"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="故障日期" prop="FaultDate">
                <el-date-picker
                  v-model="form.FaultDate"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  type="datetime"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="故障图片" prop="HeadImg" class="Describe">
            <el-upload
              :action="$rootUrl + `/Base_Manage/Upload/ProjectOssUploadFileByForm?type=6`"
              :headers="{
                Authorization: token,
              }"
              :file-list="Imgs"
              :limit="5"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :before-upload="beforeAvatarUpload"
              :class="{ 'disabled-upload': isAi ? true : disabled }"
            >
              <i class="el-icon-plus"></i>

              <!-- <el-image
                v-if="form.HeadImg"
                fit="contain"
                class="HeadImg"
                :src="form.HeadImg"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
            </el-upload>
          </el-form-item>

          <el-form-item label="故障描述" prop="FaultDescription">
            <el-input
              v-model="form.FaultDescription"
              placeholder=""
              type="textarea"
              rows="6"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-form
          v-if="isAi"
          :model="AIObj"
          ref="AIObj"
          label-width="100px"
          :rules="AIObjrules"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="供应商" prop="Amount" v-if="title === '外委'">
                <el-input
                  v-model="AIObj.SupplierName"
                  placeholder="请选择供应商"
                  disabled
                  style="width: calc(100% - 60px)"
                ></el-input>
                <el-button
                  style="width: 60px"
                  type="primary"
                  :disabled="disabled"
                  @click="openSup"
                  ><i class="el-icon-search"></i
                ></el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="合同编号" prop="Contract" v-if="title === '外委'">
                <el-input
                  v-model="AIObj.Contract"
                  type="number"
                  :disabled="disabled"
                  :controls="false"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="费用" prop="Amount" v-if="title === '外委'">
                <el-input
                  v-model="AIObj.Amount"
                  type="number"
                  :disabled="disabled"
                  :controls="false"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="人员信息" prop="OperatorIds">
                <SelectData
                  v-model="AIObj.OperatorIds"
                  multiple
                  url="/Base_Manage/Base_User/GetDataList"
                  :option="{
                    label: 'RealName',
                    Id: 'Id',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工单日期" prop="WorkOrderDate">
                <el-date-picker
                  v-model="AIObj.WorkOrderDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16" v-if="title === '外委'">
              <el-form-item label="备注">
                <el-input
                  v-model="form.Annotation"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="display: flex" v-if="isAi">
          <div
            style="
              width: 100px;
              text-align: right;
              font-size: 14px;
              padding: 0 12px 0 0;
              color: #606266;
            "
          >
            <span style="color: #f56c6c">*</span>
            建议描述
          </div>
          <quill-editor
            ref="myQuillEditor"
            v-model="AIvalue"
            :options="editorOption"
            style="height: 600px"
          />
        </div>
        <el-row v-if="isAi">
          <div style="line-height: 30px">
            <el-button type="primary" @click="addList">添加备件</el-button>
          </div>
          <el-table
            :data="MaterialsData"
            ref="MaterialsData"
            style="width: 100%"
            height="400px"
          >
            <el-table-column label="序号" width="50" type="index"> </el-table-column>

            <el-table-column label="备件编号" align="center" prop="Code" sortable>
            </el-table-column>
            <el-table-column label="备件名称" align="center" prop="Name" sortable>
            </el-table-column>
            <el-table-column
              label="备件类型"
              align="center"
              prop="MaterialTypeName"
              sortable
            >
            </el-table-column>
            <el-table-column label="备件规格" align="center" prop="Spec" sortable>
            </el-table-column>
            <el-table-column label="单位" align="center" prop="storageName" sortable>
            </el-table-column>

            <el-table-column label="货位" align="center" prop="LocalName" sortable>
            </el-table-column>
            <el-table-column label="库存数量" align="right" prop="Nums_N" sortable>
            </el-table-column>
            <el-table-column label="数量" align="center" prop="Num" sortable>
              <template slot-scope="scope">
                <el-input
                  @input="NumChange($event, scope.row)"
                  v-model="scope.row.Num"
                  type="number"
                  :controls="false"
                  style="width: 100%"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" prop="op">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="color: #f78989"
                  size="mini"
                  @click="MaterialsData.splice(scope.$index, 1)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="!disabled">保存</el-button>
      </div>
    </el-drawer>
    <DevDialog ref="DevDialog" @select="handleDevSelect" type="radio"></DevDialog>
    <AIcopyDrawer ref="AIcopyDrawer" @AI="AIchange"></AIcopyDrawer>
    <FittingsOut ref="FittingsOut" @select="selectFittingsOut"></FittingsOut>
    <Supplier ref="Supplier" type="radio" @select="selectSup"></Supplier>
  </div>
</template>
<script>
import SelectDicValue from "@/components/DicValue/SelectDicValue.vue";
import Token from "@/utils/cache/TokenCache.js";
import DevDialog from "@/components/DevDialog/DevDialog.vue";
import { mapState } from "vuex";
import AIcopyDrawer from "./AIcopyDrawer.vue";
import SelectData from "@/components/SelectData/SelectData.vue";
import FittingsOut from "@/components/Fittings/FittingsOut.vue";
import Supplier from "@/components/Supplier/Supplier.vue";
import moment from "moment";
export default {
  data() {
    return {
      editorOption: {
        theme: "snow", // 主题
        placeholder: "",
        AIshow: false,
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["clean", "link"],
              ["addBtn"],
            ], // 自定义工具栏选项
            handlers: {
              addBtn: () => {
                this.AIOpen();
              },
            },
          },
        },
      },
      row: {},
      title: "",
      loading: false,
      token: "Bearer " + Token.getToken(),
      RoleList: [],

      form: {
        DeviceItemNameJson: "",
        DeviceItemId: "",
        device_name: "",
        DeviceCode: "",
        FaultType: "",
        FaultDate: "",
        FaultDescription: "",
      },
      Imgs: [],
      rules: {
        DeviceItemNameJson: [
          { required: true, message: "请选择设备", trigger: "change" },
        ],
        FaultType: [{ required: true, message: "请选择故障类型", trigger: "change" }],
        FaultDate: [{ required: true, message: "请选择故障日期", trigger: "change" }],
        FaultDescription: [
          { required: true, message: "请填写故障描述", trigger: "blur" },
        ],
      },
      drawer: false,
      isAi: false,
      AIvalue: "",
      AIObjrules: {
        OperatorIds: [{ required: true, message: "请选择人员信息", trigger: "change" }],
        WorkOrderDate: [{ required: true, message: "请选择工单日期", trigger: "change" }],

        SupplierName: [{ required: true, message: "请选择供应商", trigger: "change" }],
        Amount: [{ required: true, message: "请输入费用", trigger: "blur" }],
      },
      AIObj: {
        SupplierName: "",
        Contract: "",
        Amount: "",
        OperatorIds: [],
        WorkOrderDate: "",
      },

      MaterialsData: [],
      disabled: false,
      dev: {},
    };
  },
  props: {},
  components: {
    Supplier,
    SelectDicValue,
    DevDialog,
    AIcopyDrawer,
    SelectData,
    FittingsOut,
  },
  methods: {
    selectSup(arr) {
      this.$set(this.AIObj, "SupplierId", arr[0].Id);
      this.$set(this.AIObj, "SupplierName", arr[0].Name);
    },
    openSup() {
      this.$refs.Supplier.openDialog();
    },
    NumChange(num, row) {
      console.log(num, row);
      if (!Number.isInteger(Number(num))) {
        this.$notify.error("数量不能为小数或负数");
        this.$set(row, "Num", Math.floor(Number(num)));
      } else if (Number(num) < 0) {
        this.$notify.error("数量不能为小数或负数");
        this.$set(row, "Num", 0);
      } else if (Number(num) > Number(row.Nums_N)) {
        this.$notify.error("数量不能超过库存数量");
        this.$set(row, "Num", row.Nums_N);
      }
    },
    selectFittingsOut(arr) {
      console.log(arr);
      if (this.MaterialsData.length == 0) {
        arr.forEach((item) => {
          this.MaterialsData.push({
            ...item,
            Num: "",
          });
        });
      } else {
        const duplicateIds = [];
        arr.forEach((item) => {
          const exists = this.MaterialsData.some(
            (detail) => detail.MaterialId === item.MaterialId
          );
          if (exists) {
            duplicateIds.push(`备件名称:${item.Name},备件编号:${item.Code}`);
          } else {
            this.MaterialsData.push({
              ...item,
              Num: "",
            });
          }
        });
        if (duplicateIds.length > 0) {
          this.$notify.warning(`以下设备已存在，未重复添加: ${duplicateIds.join(", ")}`);
        }
      }
    },
    addList() {
      this.$refs.FittingsOut.openDialog();
    },
    AIchange(value) {
      this.AIvalue = value;
    },
    AIOpen() {
      this.$refs.AIcopyDrawer.open({ ...this.form });
    },
    handlePictureCardPreview(file) {
      window.open(file.url);
    },
    handleDevSelect(arr) {
      console.log(arr);
      this.$set(this.form, "DeviceItemId", arr[0].Id);
      this.$set(this.form, "device_name", arr[0].device_name);
      this.$set(this.form, "DeviceCode", arr[0].DeviceCode);
      this.$set(
        this.form,
        "DeviceItemNameJson",
        `${this.form.device_name}(${this.form.DeviceCode})`
      );
    },
    openDevice() {
      this.$refs.DevDialog.openDialog();
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isJPG) {
        this.$notify.error("上传图片只能是 JPG 或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$notify.error("上传图片大小不能超过 20MB!");
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess(res, file, fileList) {
      console.log(file, fileList);
      console.log(res);
      this.Imgs = [...fileList];
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.Imgs = [...fileList];

      // this.Imgs = [...fileList];
    },
    handleExceed(files, fileList) {
      this.$notify.warning(`当前限制选择 9 个文件`);
    },
    getRoleList() {
      this.$http
        .post("/Base_Manage/Base_Role/GetDataList", {
          SortField: "CreateTime",
          SortType: "Desc",
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data;
          }
        });
    },
    handleSubmit() {
      if (this.isAi) {
        this.$refs.AIObj.validate((valid) => {
          if (!valid) {
            return;
          }
          if (this.MaterialsData.length > 0) {
            let isNum = this.MaterialsData.every((item) => {
              return Number(item.Num) > 0;
            });

            console.log(isNum, "every");
            if (!isNum) {
              this.$notify.error("请输入备件数量");
              return;
            }
          }
          if (!this.AIvalue) {
            return this.$notify.error("请输入或生成建议描述");
          }
          const loading = this.$loading({
            lock: true,
            text: "保存中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$http
            .post("/Base_DeviceTreeManage/Device_Fault/SubmitFaultData", {
              Id: this.row.Id,
              FaultDescription: this.AIvalue,
              OperatorIds: this.AIObj.OperatorIds ? this.AIObj.OperatorIds.join(",") : "",
              WorkOrderDate: this.AIObj.WorkOrderDate,
              SupplierName: this.AIObj.SupplierName,
              Contract: this.AIObj.Contract || "",
              Amount: this.AIObj.Amount || "",
              Annotation: this.AIObj.Annotation || "",
              SupplierId: this.AIObj.SupplierId || "",
              device_WorkOrderItems: [...this.MaterialsData],
            })
            .then((res) => {
              loading.close();

              if (res.Success) {
                this.$notify.success("操作成功!");
                this.$emit("success");
                this.close();
              } else {
                this.$notify.error(res.Msg);
              }
            });
        });

        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error("请检查输入项");
        }

        const loading = this.$loading({
          lock: true,
          text: "保存中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let imgs = [];
        if (this.Imgs.length > 0) {
          this.Imgs.forEach((item) => {
            imgs.push({
              name: item.name,
              url: item.response ? item.response.url : item.url || "",
              extname: item.extname
                ? item.extname
                : item.name.split(".")[item.name.split(".").length - 1],
            });
          });
        }
        this.$http
          .post("/Base_DeviceTreeManage/Device_Fault/SaveFaulData", {
            device_Fault: { ...this.form },
            device_FaultImgs: [...imgs],
          })
          .then((resJson) => {
            loading.close();

            if (resJson.Success) {
              this.$notify.success("操作成功!");
              this.$emit("success");
              this.close();
            } else {
              this.$notify.error(resJson.Msg);
            }
          });
      });
    },
    openForm(title, row = {}, dev, isAi = false, disabled = false) {
      this.disabled = disabled;
      this.isAi = isAi;
      this.dev = dev || {};
      this.drawer = true;
      this.row = row;
      // this.getRoleList();
      this.form = {
        DeviceItemNameJson: "",
        DeviceItemId: "",
        device_name: "",
        DeviceCode: "",
        FaultType: "",
        FaultDate: moment().format("YYYY-MM-DD HH:mm"),
        FaultDescription: "",
      };
      this.AIObj = {
        OperatorIds: [],
        WorkOrderDate: "",
      };
      this.MaterialsData = [];
      this.Imgs = [];
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        if (dev) {
          this.$set(this.form, "DeviceItemId", dev.Id);
          this.$set(this.form, "device_name", dev.device_name);
          this.$set(this.form, "DeviceCode", dev.DeviceCode);
          this.$set(
            this.form,
            "DeviceItemNameJson",
            `${this.form.device_name}(${this.form.DeviceCode})`
          );
        }
        setTimeout(() => {
          const addBtn = document.querySelector(".ql-addBtn");
          if (!addBtn) {
            return;
          }

          addBtn.className = "flex-juc-aic";

          addBtn.style = `width: 80px;height: 30px;line-height: 30px;text-align: center;color: #fff;background-color: #409eff;border-radius: 4px;cursor: pointer;padding:0;border-radius: 10px`;
          addBtn.innerHTML = `<i class='el-icon-chat-dot-round'>AI建议</i>`;
        }, 1);
      });
      this.title = title;
      if (row.Id) {
        this.getInfo(row.Id);
      }
    },
    getInfo(id) {
      this.loading = true;
      this.$http
        .post("/Base_DeviceTreeManage/Device_Fault/GetFaultTheData ", {
          id: id,
        })
        .then((resJson) => {
          this.loading = false;
          if (resJson.Success) {
            this.form = resJson.Data.device_Fault || {};
            this.$set(
              this.form,
              "DeviceItemNameJson",
              `${this.form.device_name}(${this.form.DeviceCode})`
            );
            this.Imgs = resJson.Data.device_FaultImgs || [];
          } else {
            this.$notify.error(resJson.Msg);
          }
        });
    },
    close() {
      this.drawer = false;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
::v-deep .disabled-upload {
  .el-upload--picture-card {
    display: none;
  }
}
</style>
